import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-thank-you',
  templateUrl: './thank-you.component.html',
  styleUrls: ['./thank-you.component.scss']
})
export class ThankYouComponent {
  roomNumber: string = '';
  countryCode: string = '';
  mobileNumber: string = '';
  currentTime: string;
  requestId: string = '';
  constructor(private route: ActivatedRoute, private router: Router) {
    this.currentTime = this.getCurrentTime();
    this.route.paramMap.subscribe(params => {
      this.countryCode = params.get('countryCode') || '';
      this.mobileNumber = params.get('phoneNumber') || '';
      this.roomNumber = params.get('roomNumber') || '';
      this.requestId = params.get('requestId') || '';
    });
  }

  goHome() {
    this.router.navigate(['/']);
  }

  getCurrentTime(): string {
    const now = new Date();
    const dateOptions: Intl.DateTimeFormatOptions = {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    };
    const timeOptions: Intl.DateTimeFormatOptions = {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    };
    return `${now.toLocaleTimeString('en-US', timeOptions)} & ${now.toLocaleDateString('en-US', dateOptions)}`;
  }
}
